import { render, staticRenderFns } from "./EditLanguagesAndSkillsAction.vue?vue&type=template&id=707ba57f&scoped=true&"
import script from "./EditLanguagesAndSkillsAction.vue?vue&type=script&lang=js&"
export * from "./EditLanguagesAndSkillsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ba57f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
